import { reaction } from 'mobx';
/**
 * Watches all observables accessed during the getState callback.
 * When any of the value of these observables change, forceUpdate is called on the component.
 */
var StateObserver = /** @class */ (function () {
    function StateObserver(component, getState) {
        this.component = component;
        this.getState = getState;
        this.inUpdate = false;
        this.isPaused = false;
    }
    StateObserver.prototype.observe = function () {
        var _this = this;
        if (!this.inUpdate) {
            this.dispose();
            this._disposer = reaction(function () {
                return _this.getState();
            }, function (newState) {
                if (!_this.isPaused) {
                    _this.inUpdate = true;
                    _this.component.forceUpdate();
                    _this.inUpdate = false;
                }
            });
        }
    };
    StateObserver.prototype.dispose = function () {
        if (this._disposer)
            this._disposer();
        this._disposer = undefined;
    };
    return StateObserver;
}());
export { StateObserver };
